// El servidor guarda 24 h la respuesta que no pudo entregar (WebSocket
// cerrado): pasado eso ya no hay nada que recuperar.
const RECOVERABLE_TURN_MS = 24 * 60 * 60 * 1000;

/**
 * Pregunta del historial que quedó sin respuesta pero se puede recuperar:
 * el último turno es una pregunta (sin `text`) con el invocation_id que dio
 * el servidor al aceptarla (`pendingInvocationId`). Pasa cuando la página se
 * recargó o el teléfono la descartó mientras el turno corría en el servidor.
 */
export const unansweredTurnToRecover = (turns, now = Date.now()) => {
    const last = turns[turns.length - 1];
    if (!last || !last.query || last.text !== undefined || !last.pendingInvocationId) {
        return null;
    }
    if (last.askedAt && now - last.askedAt > RECOVERABLE_TURN_MS) {
        return null;
    }
    return last;
};
